<span class="okc-section-title">{{ topToolbarConfig()?.title }}</span>

<span class="flex-spacer"></span>

@if (!isMobile()) {
  <nav
    mat-tab-nav-bar
    [tabPanel]="tabPanel"
    class="okc-mat-tab-nav-bar"
  >
    @for (menuItem of topToolbarConfig()?.menuItems; track menuItem.path) {
      <a
        mat-tab-link
        [routerLink]="menuItem.path"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
      >
        @if (menuItem?.icon) {
          <mat-icon class="icon-sm">{{ menuItem.icon }}</mat-icon>
        }
        {{ menuItem.label }}
      </a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
}

<span class="flex-spacer"></span>

<div class="ock-nav-quick-actions">
  <button
    matIconButton
    aria-label="Buscar"
  >
    <mat-icon>search</mat-icon>
  </button>

  <button
    matIconButton
    aria-label="Notificaciones"
    [matBadge]="notificationTopToolbarCount()"
    matBadgeColor="warn"
    matBadgePosition="after"
    [matBadgeHidden]="notificationTopToolbarCount() === 0"
  >
    <mat-icon>notifications</mat-icon>
  </button>

  @if (topToolbarConfig()?.quickActions && topToolbarConfig()!.quickActions.length > 0) {
    <mat-menu #quickActionsMenu="matMenu">
      @for (quickAction of topToolbarConfig()?.quickActions; track quickAction.path) {
        <button
          mat-menu-item
          [routerLink]="quickAction.path"
        >
          <mat-icon>{{ quickAction.icon }}</mat-icon>
          <span>{{ quickAction.label }}</span>
        </button>
      }
    </mat-menu>
    <button
      matIconButton
      aria-label="Acciones rápidas / más opciones"
      [matMenuTriggerFor]="quickActionsMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  }
</div>
